
import React from 'react';
import EntityDetailLayout from '../../EntityDetailLayout';

interface TransactionErrorProps {
  error: string | null;
  onClose: () => void;
}

const TransactionError: React.FC<TransactionErrorProps> = ({ error, onClose }) => {
  return (
    <EntityDetailLayout title="Error" onClose={onClose}>
      <div className="py-6 text-center">
        <h3 className="text-lg font-medium text-destructive mb-2">Something went wrong</h3>
        <p className="text-muted-foreground">{error}</p>
      </div>
    </EntityDetailLayout>
  );
};

export default TransactionError;
